import React, { useRef, useCallback, useState } from "react";
import { Question } from "interfaces/question";

import * as S from "./styles";
import { max } from "lodash";

interface InterviewProsp {
  questions: Question[];
  lightMode?: boolean;
}
export const Interview: React.FC<InterviewProsp> = ({
  questions,
  lightMode,
}) => {
  const itemsRef = useRef<HTMLDivElement>(null);
  const [currentQuestion, setCurrentQuestion] = useState<number>(0);

  type Direction = "next" | "prev";
  const handleQuestionPosition = useCallback(
    (direction: Direction) => {
      const maxQuestion = questions.length - 1;
      const nextPosition =
        direction === "next" ? currentQuestion + 1 : currentQuestion - 1;

      const position =
        nextPosition >= 0 && nextPosition <= maxQuestion ? nextPosition : 0;

      const widthElement = itemsRef.current?.offsetWidth || 0;
      itemsRef.current?.scrollTo(position * widthElement, 0);
      setCurrentQuestion(position);
    },
    [currentQuestion, questions]
  );
  return (
    <S.Container lightMode={lightMode}>
      <S.ItemsWrapper ref={itemsRef}>
        {questions.map((question) => (
          <S.Item key={question.id}>
            <S.QuestionNumber>
              <span>{question.id}</span>
              <S.IconArrowForward />
            </S.QuestionNumber>
            <S.QuestionWrapper>
              <S.Question>{question.title}</S.Question>
              <S.Answer>{question.answer}</S.Answer>
            </S.QuestionWrapper>
          </S.Item>
        ))}
      </S.ItemsWrapper>
      <S.Controls>
        <S.ButtonPrev onClick={() => handleQuestionPosition("prev")}>
          <S.IconArrowPrev />
        </S.ButtonPrev>
        <S.ButtonNext onClick={() => handleQuestionPosition("next")}>
          <S.IconArrowNext />
        </S.ButtonNext>
      </S.Controls>
    </S.Container>
  );
};
